import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "@/auth/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const sessionId = m ? decodeURIComponent(m[1]) : null;

        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }

        (async () => {
            try {
                const res = await axios.post(`${API}/auth/google/session`, {
                    session_id: sessionId,
                });
                const { user, session_token } = res.data;
                if (session_token) {
                    localStorage.setItem("session_token", session_token);
                }
                setUser(user);
                toast.success(`Welcome${user?.name ? `, ${user.name.split(" ")[0]}` : ""}! 🌴`);
                // Strip fragment and go to account
                window.history.replaceState(
                    {},
                    "",
                    window.location.origin + "/account"
                );
                navigate("/account", { replace: true, state: { user } });
            } catch (err) {
                console.error(err);
                toast.error("Sign-in failed. Please try again.");
                navigate("/", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-cream">
            <div className="text-center">
                <div className="text-5xl mb-3">🌴</div>
                <p className="text-navy font-bold">Signing you in…</p>
            </div>
        </div>
    );
}
